import * as THREE from "three";
// Source sky brushes occlude other rooms while displaying the far-away sky.
export function sourceSkyMaterial(scene: THREE.Scene) {
  if (!(scene.background instanceof THREE.CubeTexture))
    return new THREE.MeshBasicMaterial({
      color:
        scene.background instanceof THREE.Color ? scene.background : 0x91a7ba,
    });
  const inverse = new THREE.Matrix4()
    .makeRotationFromEuler(scene.backgroundRotation)
    .invert();
  return new THREE.ShaderMaterial({
    uniforms: {
      sky: { value: scene.background },
      rotation: { value: new THREE.Matrix3().setFromMatrix4(inverse) },
    },
    vertexShader: `varying vec3 skyPosition; void main(){vec4 world=modelMatrix*vec4(position,1.0);skyPosition=world.xyz;gl_Position=projectionMatrix*viewMatrix*world;}`,
    fragmentShader: `uniform samplerCube sky; uniform mat3 rotation; varying vec3 skyPosition; void main(){vec3 direction=rotation*normalize(skyPosition-cameraPosition);direction.x=-direction.x;gl_FragColor=textureCube(sky,direction);
#include <colorspace_fragment>
}`,
    depthWrite: true,
    depthTest: true,
    toneMapped: false,
  });
}

export function sourceLitMaterial(
  m: THREE.MeshStandardMaterial,
  lightmap: THREE.Texture,
  intensity = 1,
) {
  const material = new THREE.MeshBasicMaterial({
    map: m.map,
    color: m.color,
    lightMap: lightmap,
    lightMapIntensity: intensity * Math.PI,
    side: m.side,
    transparent: m.transparent,
    opacity: m.opacity,
    alphaTest: m.alphaTest,
  });
  // A restrained ambient floor keeps original dark HDR sections readable without flattening their baked highlights.
  material.onBeforeCompile = (shader) => {
    shader.fragmentShader = shader.fragmentShader.replace(
      "reflectedLight.indirectDiffuse *= diffuseColor.rgb;",
      "reflectedLight.indirectDiffuse = max(reflectedLight.indirectDiffuse, vec3(0.12)); reflectedLight.indirectDiffuse *= diffuseColor.rgb;",
    );
  };
  material.customProgramCacheKey = () => "source-baked-lighting-ambient-v1";
  return material;
}
